import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Container from '../components/layout/Container';
import PlayerStats from '../components/stats/PlayerStats';
import Loading from '../components/common/Loading';
import ErrorMessage from '../components/common/ErrorMessage';
import { getPlayerStats } from '../services/public-api';
import './PlayerProfilePage.css';

/**
 * PlayerProfilePage
 * Shows individual player statistics
 * T076: Player profile page with individual statistics
 */
const PlayerProfilePage = () => {
  const { playerId } = useParams();
  const [player, setPlayer] = useState(null);
  const [team, setTeam] = useState(null);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (playerId) {
      fetchPlayerStats();
    }
  }, [playerId]);

  const fetchPlayerStats = async () => {
    setLoading(true);
    setError(null);

    try {
      const data = await getPlayerStats(playerId);
      setPlayer(data.player);
      setTeam(data.team);
      setStats(data.stats);
    } catch (err) {
      setError(err.message || 'Failed to load player statistics');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Container>
        <Loading size="large" />
      </Container>
    );
  }

  if (error) {
    return (
      <Container>
        <ErrorMessage
          message={error}
          variant="error"
          onRetry={fetchPlayerStats}
        />
      </Container>
    );
  }

  if (!player) {
    return (
      <Container>
        <div className="not-found">
          <h1>Player Not Found</h1>
          <p>The player you're looking for doesn't exist.</p>
        </div>
      </Container>
    );
  }

  return (
    <Container>
      <div className="player-profile-page">
        <div className="page-header">
          {team && (
            <Link to={`/teams/${team.teamId}`} className="back-link">
              ← Back to Team
            </Link>
          )}
          <h1>Player Profile</h1>
        </div>

        <PlayerStats player={player} team={team} stats={stats} />
      </div>
    </Container>
  );
};

export default PlayerProfilePage;
